// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__v+J6C","close":"CloseButton_close__i0HAU"};